import React, { useEffect, useState } from "react";

import { LoadingDiv, SweetAlertShow } from "../master/Master";

import Header from "../master/SideBar";
import Nav from "../master/NavBar";
import Master from "./Master";

import usePrivateLink from "../config/usePrivateLink";

import { documentsList } from "../../api/CollectionDistribution";

import { useSearchParams } from "react-router-dom";

import { imgBaseUrl } from "../../api/api";

export default function StudentDocuments() {
  const hasAccess = usePrivateLink();

  const [searchParams] = useSearchParams();

  const enquiry_id = searchParams.get("enquiry_id") || "";

  const [loading, setLoading] = useState(false);

  const [data, setData] = useState({});

  const [selectedDocuments, setSelectedDocuments] = useState([]);

  const [filters, setFilters] = useState({
    page: 1,
    search: "",
    type: "student",
  });

  // GET DATA
  const getData = async () => {
    setLoading(true);

    try {
      let url = `?page=${filters.page}&type=${filters.type}`;

      if (enquiry_id) {
        url += `&enquiry_id=${enquiry_id}`;
      }

      if (filters.search) {
        url += `&search=${filters.search}`;
      }

      const response = await documentsList(url);

      if (response.data.status) {
        setData(response.data.data);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
        error?.response?.message ??
        error?.message,
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      getData();
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [filters.page, filters.type, filters.search, enquiry_id]);

  const documentCount = data?.data?.reduce(
    (total, item) => total + (item?.documents?.length || 0),
    0,
  );

  return (
    <>
      {loading && <LoadingDiv />}

      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <Nav />

            <div className="content-wrapper">
              <div className="container-fluid flex-grow-1 container-p-y">
                <div className="row">
                  <Master />

                  {/* PAGE HEADER */}
                  <div className="col-12 mb-4">
                    <div className="card">
                      <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                          <div className="d-flex align-items-center gap-3">
                            <div
                              className="avatar avatar-lg"
                              style={{
                                width: "52px",
                                height: "52px",
                              }}
                            >
                              <span className="avatar-initial rounded bg-label-primary">
                                <i className="ri-folder-user-line fs-3"></i>
                              </span>
                            </div>

                            <div>
                              <h4 className="mb-1">Student Documents</h4>

                              <p className="text-muted mb-0">
                                View and manage uploaded documents
                              </p>
                            </div>
                          </div>

                          <div className="d-flex align-items-center gap-2">
                            <span className="badge rounded-pill bg-label-primary px-3 py-2">
                              <i className="ri-file-list-3-line me-1"></i>
                              {documentCount || 0} Documents
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* TYPE TABS */}
                  <div className="col-12 mb-4">
                    <div className="card">
                      <div className="card-body py-3">
                        <div className="d-flex align-items-center justify-content-between flex-wrap gap-3">
                          <div>
                            <h6 className="mb-1">Document Type</h6>
                            <small className="text-muted">
                              Select the category you want to view
                            </small>
                          </div>

                          <div
                            className="d-flex gap-2 flex-wrap"
                            role="tablist"
                          >
                            {[
                              {
                                label: "Student",
                                value: "student",
                                icon: "ri-user-line",
                              },
                              {
                                label: "Enquiry",
                                value: "enquiry",
                                icon: "ri-user-search-line",
                              },
                              {
                                label: "Staff",
                                value: "staff",
                                icon: "ri-user-settings-line",
                              },
                            ].map((item) => {
                              const isActive = filters.type === item.value;

                              return (
                                <button
                                  key={item.value}
                                  type="button"
                                  className={`btn ${isActive
                                      ? "btn-primary"
                                      : "btn-outline-primary"
                                    } d-flex align-items-center gap-2`}
                                  onClick={() =>
                                    setFilters((prev) => ({
                                      ...prev,
                                      type: item.value,
                                      page: 1,
                                    }))
                                  }
                                >
                                  <i className={item.icon}></i>
                                  <span>{item.label}</span>
                                </button>
                              );
                            })}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* MAIN DOCUMENT CARD */}
                  <div className="col-12">
                    <div className="card">
                      {/* CARD HEADER */}
                      <div className="card-header border-bottom">
                        <div className="d-flex justify-content-between align-items-center flex-wrap gap-3">
                          <div>
                            <h5 className="mb-1">
                              {filters.type === "student"
                                ? "Student Documents"
                                : filters.type === "enquiry"
                                  ? "Enquiry Documents"
                                  : "Staff Documents"}
                            </h5>

                            <small className="text-muted">
                              Browse uploaded documents and view their details
                            </small>
                          </div>

                          {/* SEARCH */}
                          <div
                            className="position-relative"
                            style={{ minWidth: "300px" }}
                          >
                            <i
                              className="ri-search-line position-absolute text-muted"
                              style={{
                                left: "12px",
                                top: "50%",
                                transform: "translateY(-50%)",
                                zIndex: 2,
                              }}
                            ></i>

                            <input
                              type="text"
                              className="form-control ps-5"
                              placeholder="Search student, registration no..."
                              value={filters.search}
                              onChange={(e) =>
                                setFilters((prev) => ({
                                  ...prev,
                                  search: e.target.value,
                                  page: 1,
                                }))
                              }
                            />

                            {filters.search && (
                              <button
                                type="button"
                                className="btn btn-sm position-absolute p-0 text-muted"
                                style={{
                                  right: "12px",
                                  top: "50%",
                                  transform: "translateY(-50%)",
                                  zIndex: 2,
                                }}
                                onClick={() =>
                                  setFilters((prev) => ({
                                    ...prev,
                                    search: "",
                                    page: 1,
                                  }))
                                }
                              >
                                <i className="ri-close-circle-line fs-5"></i>
                              </button>
                            )}
                          </div>
                        </div>
                      </div>

                      {/* TABLE */}
                      <div className="card-body p-0">
                        <div className="table-responsive">
                          <table className="table table-hover align-middle mb-0">
                            <thead className="table-light">
                              <tr>
                                <th
                                  className="text-center"
                                  style={{ width: "70px" }}
                                >
                                  #
                                </th>

                                <th>Student</th>

                                <th>Registration No.</th>

                                <th>Father Name</th>

                                <th>Mobile</th>

                                <th className="text-center">Documents</th>

                                <th
                                  className="text-center"
                                  style={{ width: "120px" }}
                                >
                                  Action
                                </th>
                              </tr>
                            </thead>

                            <tbody>
                              {data?.data?.length > 0 ? (
                                data.data.map((item, i) => (
                                  <tr key={item.id}>
                                    {/* INDEX */}
                                    <td className="text-center">
                                      <span className="text-muted fw-medium">
                                        {(data.current_page - 1) *
                                          data.per_page +
                                          i +
                                          1}
                                      </span>
                                    </td>

                                    {/* STUDENT */}
                                    <td>
                                      <div className="d-flex align-items-center gap-3">
                                        <div
                                          className="avatar avatar-sm"
                                          style={{
                                            width: "38px",
                                            height: "38px",
                                          }}
                                        >
                                          <span className="avatar-initial rounded-circle bg-label-primary">
                                            <i className="ri-user-line"></i>
                                          </span>
                                        </div>

                                        <div>
                                          <div className="fw-semibold">
                                            {item?.student_name ??
                                              item?.name ??
                                              "-"}
                                          </div>

                                          <small className="text-muted">
                                            {filters.type === "student"
                                              ? "Student"
                                              : filters.type === "enquiry"
                                                ? "Enquiry"
                                                : "Staff"}
                                          </small>
                                        </div>
                                      </div>
                                    </td>

                                    {/* REGISTRATION */}
                                    <td>
                                      <span className="fw-medium">
                                        {item?.registration_no ??
                                          item?.enquiry_no ??
                                          "-"}
                                      </span>
                                    </td>

                                    {/* FATHER NAME */}
                                    <td>
                                      <span>{item?.father_name ?? "-"}</span>
                                    </td>

                                    {/* MOBILE */}
                                    <td>
                                      <div className="d-flex align-items-center gap-2">
                                        <i className="ri-phone-line text-muted"></i>

                                        <span>
                                          {item?.mobile ?? item?.phone ?? "-"}
                                        </span>
                                      </div>
                                    </td>

                                    {/* DOCUMENT COUNT */}
                                    <td className="text-center">
                                      <span className="badge rounded-pill bg-label-info px-3 py-2">
                                        <i className="ri-file-text-line me-1"></i>
                                        {item?.documents?.length || 0} Docs
                                      </span>
                                    </td>

                                    {/* ACTION */}
                                    <td className="text-center">
                                      {hasAccess("/document/view") && (

                                        <button
                                          type="button"
                                          className="btn btn-sm btn-outline-primary"
                                          data-bs-toggle="modal"
                                          data-bs-target="#documentModal"
                                          onClick={() =>
                                            setSelectedDocuments(
                                              item?.documents || [],
                                            )
                                          }
                                        >
                                          <i className="ri-eye-line me-1"></i>
                                          View
                                        </button>
                                      )}
                                    </td>
                                  </tr>
                                ))
                              ) : (
                                <tr>
                                  <td colSpan="7">
                                    <div className="card border-0 shadow-none mb-0">
                                      <div className="card-body text-center py-5">
                                        <div
                                          className="avatar avatar-xl mx-auto mb-3"
                                          style={{
                                            width: "70px",
                                            height: "70px",
                                          }}
                                        >
                                          <span className="avatar-initial rounded-circle bg-label-secondary">
                                            <i className="ri-folder-open-line fs-2"></i>
                                          </span>
                                        </div>

                                        <h5 className="mb-2">
                                          No Records Found
                                        </h5>

                                        <p className="text-muted mb-0">
                                          {filters.search
                                            ? "No records match your search criteria."
                                            : "No documents are available for this category."}
                                        </p>

                                        {filters.search && (
                                          <button
                                            type="button"
                                            className="btn btn-sm btn-outline-primary mt-3"
                                            onClick={() =>
                                              setFilters((prev) => ({
                                                ...prev,
                                                search: "",
                                                page: 1,
                                              }))
                                            }
                                          >
                                            <i className="ri-refresh-line me-1"></i>
                                            Clear Search
                                          </button>
                                        )}
                                      </div>
                                    </div>
                                  </td>
                                </tr>
                              )}
                            </tbody>
                          </table>
                        </div>
                      </div>

                      {/* CARD FOOTER */}
                      {data?.data?.length > 0 && (
                        <div className="card-footer border-top">
                          <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                            <small className="text-muted">
                              Showing{" "}
                              <strong>
                                {(data.current_page - 1) * data.per_page + 1}
                              </strong>{" "}
                              to{" "}
                              <strong>
                                {Math.min(
                                  data.current_page * data.per_page,
                                  data.total,
                                )}
                              </strong>{" "}
                              of <strong>{data.total}</strong> records
                            </small>

                            <div className="d-flex align-items-center gap-2">
                              {data.current_page > 1 && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() =>
                                    setFilters((prev) => ({
                                      ...prev,
                                      page: prev.page - 1,
                                    }))
                                  }
                                >
                                  <i className="ri-arrow-left-line me-1"></i>
                                  Previous
                                </button>
                              )}

                              {data.current_page < data.last_page && (
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={() =>
                                    setFilters((prev) => ({
                                      ...prev,
                                      page: prev.page + 1,
                                    }))
                                  }
                                >
                                  Next
                                  <i className="ri-arrow-right-line ms-1"></i>
                                </button>
                              )}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* DOCUMENT MODAL */}
      <div
        className="modal fade"
        id="documentModal"
        tabIndex="-1"
        aria-labelledby="documentModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            {/* MODAL HEADER */}
            <div className="modal-header">
              <div>
                <h5 className="modal-title mb-1" id="documentModalLabel">
                  Documents List
                </h5>

                <small className="text-muted">
                  {selectedDocuments.length} document
                  {selectedDocuments.length !== 1 ? "s" : ""} available
                </small>
              </div>

              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>

            {/* MODAL BODY */}
            <div className="modal-body">
              {selectedDocuments.length > 0 ? (
                <div className="row g-3">
                  {selectedDocuments.map((doc, index) => (
                    <div className="col-md-6" key={doc.id || index}>
                      <div className="card h-100 border">
                        <div className="card-body">
                          {/* DOCUMENT TITLE */}
                          <div className="d-flex align-items-start justify-content-between gap-2 mb-3">
                            <div className="d-flex align-items-center gap-2">
                              <div
                                className="avatar avatar-sm"
                                style={{
                                  width: "38px",
                                  height: "38px",
                                }}
                              >
                                <span className="avatar-initial rounded bg-label-primary">
                                  <i className="ri-file-text-line"></i>
                                </span>
                              </div>

                              <div>
                                <h6 className="mb-0">
                                  {doc?.document_type?.document_name ??
                                    "Document"}
                                </h6>

                                <small className="text-muted">
                                  Document #{index + 1}
                                </small>
                              </div>
                            </div>
                          </div>

                          {/* DOCUMENT DETAILS */}
                          <div className="border rounded p-3 mb-3">
                            <div className="d-flex justify-content-between gap-3 mb-2">
                              <span className="text-muted small">
                                Document Number
                              </span>

                              <span className="fw-medium small text-end">
                                {doc?.document_number || "-"}
                              </span>
                            </div>

                            <div className="d-flex justify-content-between gap-3 mb-2">
                              <span className="text-muted small">School</span>

                              <span className="fw-medium small text-end">
                                {doc?.school_name || "-"}
                              </span>
                            </div>

                            <div className="d-flex justify-content-between gap-3 mb-2">
                              <span className="text-muted small">
                                Education Year
                              </span>

                              <span className="fw-medium small text-end">
                                {doc?.education_year || "-"}
                              </span>
                            </div>

                            <div className="d-flex justify-content-between gap-3">
                              <span className="text-muted small">Score</span>

                              <span className="fw-medium small text-end">
                                {doc?.score || "-"}
                              </span>
                            </div>
                          </div>

                          {/* VIEW BUTTON */}
                          {doc?.file ? (
                            <a
                              href={imgBaseUrl + doc.file}
                              target="_blank"
                              rel="noreferrer"
                              className="btn btn-primary btn-sm w-100"
                            >
                              <i className="ri-eye-line me-1"></i>
                              View Document
                            </a>
                          ) : (
                            <button
                              type="button"
                              className="btn btn-outline-secondary btn-sm w-100"
                              disabled
                            >
                              <i className="ri-file-forbid-line me-1"></i>
                              File Not Available
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              ) : (
                <div className="card border">
                  <div className="card-body text-center py-5">
                    <div
                      className="avatar avatar-xl mx-auto mb-3"
                      style={{
                        width: "65px",
                        height: "65px",
                      }}
                    >
                      <span className="avatar-initial rounded-circle bg-label-secondary">
                        <i className="ri-file-forbid-line fs-2"></i>
                      </span>
                    </div>

                    <h6 className="mb-1">No Documents Available</h6>

                    <p className="text-muted mb-0">
                      There are no documents uploaded for this record.
                    </p>
                  </div>
                </div>
              )}
            </div>

            {/* MODAL FOOTER */}
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-outline-secondary"
                data-bs-dismiss="modal"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
